import Icon from '@/components/ui/AppIcon';

const TrustBadges = () => {
  const badges = [
    {
      icon: 'ShieldCheckIcon',
      title: 'GST Compliant',
      description: 'Registered Indian Business'
    },
    {
      icon: 'CheckBadgeIcon',
      title: 'Export Quality',
      description: 'International Standards'
    },
    {
      icon: 'GlobeAltIcon',
      title: 'Global Shipping',
      description: 'Worldwide Delivery'
    }
  ];

  return (
    <div className="w-full">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
        {badges?.map((badge, index) => (
          <div
            key={index}
            className="flex flex-col items-center text-center p-4 md:p-6 bg-card border border-border rounded-md transition-smooth hover:border-primary/30"
          >
            <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-primary/10 rounded-full mb-3">
              <Icon 
                name={badge?.icon} 
                size={24} 
                className="text-primary"
              />
            </div>
            <h3 className="text-sm md:text-base font-semibold text-foreground mb-1">
              {badge?.title}
            </h3>
            <p className="text-xs md:text-sm text-muted-foreground caption">
              {badge?.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustBadges;